<template>
  <v-card class="mb-4 rounded-lg" outlined>
    <v-card-text>
      <div class="d-flex align-center justify-space-between" style="gap: 12px">
        <div style="min-width: 0">
          <h6 >
            {{ $t("bundle_products") }}
          </h6>
          <p class="mb-0 text-caption grey--text">
            {{ $t("bundle_products_desc") }}
          </p>
        </div>
        <v-switch
          :value="isBundle"
          @change="onToggle"
          inset
          dense
          hide-details
          class="ma-0 pa-0 flex-grow-0 flex-shrink-0"
        />
      </div>

      <div v-if="isBundle" class="mt-3">
        <div class="d-flex mb-3">
          <v-text-field
            v-model="bundleSearch"
            :placeholder="$t('search_product_by_name_or_barcode')"
            hide-details
            outlined
            dense
            class="flex-grow-1 mr-2"
            clearable
            clear-icon="fal fa-times"
            @keyup.enter="searchBundleProduct"
            @click:clear="clearSearch"
          />
          <v-btn
            color="primary"
            @click="searchBundleProduct"
            :loading="isSearching"
            :disabled="!bundleSearch || isSearching"
          >
            <v-icon left v-if="!isSearching">fal fa-search</v-icon>
            {{ isSearching ? $t("searching") : $t("search") }}
          </v-btn>
        </div>

        <v-simple-table v-if="localItems.length">
          <thead>
            <tr>
              <th>{{ $t("image") }}</th>
              <th class="text-left" style="width: 200px">
                {{ $t("product") }}
              </th>
              <th class="text-left">{{ $t("price") }}</th>
              <th class="text-left" style="width: 100px">{{ $t("qty") }}</th>
              <th class="text-right">{{ $t("action") }}</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(bp, idx) in localItems" :key="bp.product_id">
              <td>
                <app-img
                  width="35"
                  height="35"
                  :img="bp.product?.img"
                  :alt="bp.product?.name"
                />
              </td>
              <td class="text-left">
                {{ bp.product?.name | nameLimit(15) }}
              </td>
              <td>
                <span class="font-weight-bold primary--text">
                  {{ base_price(bp.product) | NumberFormat }}
                </span>
              </td>
              <td class="text-left">
                <CurrencyInput
                  dense
                  v-model="bp.quantity"
                  @input="onQuantityChange"
                />
              </td>
              <td class="text-right">
                <v-btn icon x-small color="error" @click="removeBundleItem(idx)"
                  ><v-icon small>fal fa-trash</v-icon></v-btn
                >
              </td>
            </tr>
          </tbody>
        </v-simple-table>
      </div>
    </v-card-text>
  </v-card>
</template>

<script>
import CurrencyInput from "@/components/CurrencyInput";
import { myMixin } from "@/mixin/main";

export default {
  name: "ProductBundleBuilder",
  mixins: [myMixin],
  components: {
    CurrencyInput,
  },
  props: {
    isBundle: {
      type: Boolean,
      default: false,
    },
    items: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      bundleSearch: "",
      bundleQty: 1,
      localItems: [],
      isSearching: false,
    };
  },
  watch: {
    items: {
      immediate: true,
      handler(val) {
        this.localItems = Array.isArray(val)
          ? JSON.parse(JSON.stringify(val))
          : [];
      },
    },
  },
  methods: {
    onToggle(val) {
      this.$emit("update:isBundle", val);
      if (!val) {
        // when toggled off, clear items and emit empty array
        this.localItems = [];
        this.emitItems();
      }
    },
    async searchBundleProduct() {
      try {
        if (!this.bundleSearch) return;
        this.isSearching = true;
        const params = {
          q: this.bundleSearch,
          is_bundle: 1,
          has_variations: 1,
        };
        const { data } = await this.$http.get(`product_search`, { params });
        if (data && data.status && data.data) {
          // check if product already exists + increase quantity
          const exists = this.localItems.find(
            (x) => x.product_id === data.data.id
          );
          if (exists) {
            exists.quantity += 1;
          } else {
            // push to localItems
            this.localItems.push({
              product_id: data.data.id,
              quantity: 1,
              product: data.data,
            });
            console.log(
              "ProductBundleBuilder - Added bundle item:",
              data.data.name
            );
          }
          // clear search
          this.bundleSearch = "";
          // Emit updated items to parent
          this.emitItems();
          // User can adjust quantity and click add button
        }
      } catch (e) {
        console.error("Search error:", e);
      } finally {
        this.isSearching = false;
      }
    },

    removeBundleItem(idx) {
      this.localItems.splice(idx, 1);
      this.emitItems();
    },
    onQuantityChange() {
      // Emit items when quantity changes
      this.emitItems();
    },
    emitItems() {
      console.log("ProductBundleBuilder - Emitting items:", this.localItems);
      this.$emit("update:items", JSON.parse(JSON.stringify(this.localItems)));
    },
    formatPrice(price) {
      if (!price) return "0.00";
      return parseFloat(price).toFixed(2);
    },

    clearSearch() {
      this.bundleSearch = "";
      this.bundleSearchResult = null;
    },
    base_price(product) {
      // Since backend now stores original prices, no conversion needed
      if (product?.price_sale && product?.price_sale > 0) {
        return Number(product?.price_sale);
      } else {
        return 0;
      }
    },
  },
};
</script>

<style scoped></style>
